import { Component, Input } from '@angular/core';
import {
  CadastroContratoDto,
  MaritalStatus,
  OwnerDto,
  PropertyDto,
  PropertyUsage,
  ReurbModalidade
} from '@usucampeao/lib-reurb-simplificado';
import { NumeroExtensoTipo } from '@usucampeao/utils';

@Component({
  selector: 'usucampeao-contrato-cdhu',
  templateUrl: './contrato-cdhu.component.html',
  styleUrls: ['./contrato-cdhu.component.scss']
})
export class ContratoCdhuComponent {
  @Input() cadastro!: CadastroContratoDto;
  @Input() proprietario!: Partial<OwnerDto>;
  @Input() conjuge!: Partial<OwnerDto>;
  @Input() imovel!: Partial<PropertyDto>;
  @Input() isPrint: boolean;

  public get imovelTipo(): typeof PropertyUsage {
    return PropertyUsage;
  }

  public get numeroExtensoTipo(): typeof NumeroExtensoTipo {
    return NumeroExtensoTipo;
  }

  public get reurbModalidade(): typeof ReurbModalidade {
    return ReurbModalidade;
  }

  public get estadoCivil(): typeof MaritalStatus {
    return MaritalStatus;
  }

  public get pagamentoAVista(): boolean {
    return !this.cadastro?.totalParcelas || this.cadastro.totalParcelas === 0;
  }
}
